var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":_vm.website + _vm.url,"target":"_blank"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }